var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"TransactionHistoryError"},[_c('h3',[_vm._v("Aconteceu algum problema de conexão, tente novamente.")]),_c('AppButton',{on:{"click":_vm.tryToFetchTransactionsAgain}},[_vm._v(" Buscar transações ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }